export const tutorial: Record<string, string> = {
	tutorial_1_1: "Move around with these keys:",
	tutorial_1_2: "You can also use numpad or arrow keys",
	tutorial_1_4: "<- Go to the stairs",
	tutorial_2_1: "<- That door is locked.",
	tutorial_2_2: "Use the terminal to open the door",
	tutorial_2_3: "(move towards it to operate)",
	tutorial_2_4: "Walk diagonally here.",
	tutorial_2_5: "You can also move around",
	tutorial_2_6: "using the mouse.",
	tutorial_3_1: "Get a weapon from the box.",
	tutorial_3_2: "Kill the enemies in the other room.",
	tutorial_3_3: "SHIFT + direction to shoot, or SHIFT + click",
	tutorial_3_5: "Wait with [x] [.] or numpad [0] and [5]",
	tutorial_3_7: "Projectiles move 1 tile per turn, same as you",
	tutorial_3_9: "Get the cannon",
	tutorial_3_10: "Blast the barrels on the corridor",
	tutorial_3_11: "Select weapon with 0-9 or by clicking",
	tutorial_3_14: "You spent all your ammo, get some more.",
	tutorial_3_16: "Blast the barrels on the corridor",
	tutorial_4_1: "Use the key to open the crate",
	tutorial_4_3: "This door is locked",
	tutorial_4_4: "It can only be opened by missiles.",
	tutorial_4_6: "Go outside, kill the enemies",
	tutorial_4_8: "Portals continually spawn enemies  ",
	tutorial_4_9: "Destroy them with cannon or missiles",
	tutorial_4_10: "Great!",
	tutorial_4_11: "You finished the tutorial.",
	tutorial_4_12: "Go back to the main menu to start a new game.",
};
